/* eslint-disable @typescript-eslint/naming-convention */
export enum HttpErrorCodes {
    FAILED_VALIDATION = 'FAILED_VALIDATION',
    FORBIDDEN = 'FORBIDDEN',
    INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
    INVALID_IP = 'INVALID_IP',
    INVALID_OTP = 'INVALID_OTP',
    INVALID_PAYLOAD = 'INVALID_PAYLOAD',
    INVALID_QUERY = 'INVALID_QUERY',
    INVALID_TOKEN = 'INVALID_TOKEN',
    RECORD_NOT_UNIQUE = 'RECORD_NOT_UNIQUE',
    REQUESTS_EXCEEDED = 'REQUESTS_EXCEEDED',
    ROUTE_NOT_FOUND = 'ROUTE_NOT_FOUND',
    SERVICE_UNAVAILABLE = 'SERVICE_UNAVAILABLE',
    TOKEN_EXPIRED = 'TOKEN_EXPIRED',
    UNPROCESSABLE_CONTENT = 'UNPROCESSABLE_CONTENT',
    UNSUPPORTED_MEDIA_TYPE = 'UNSUPPORTED_MEDIA_TYPE'
}
